import {AnyAction} from 'redux';

import * as at from './upload_action_types';

const defaultState = {
  isUploadingCounter: 0,
  uploadedFiles: [],
  isUploadSuccessful: true,
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case at.UPLOAD: {
      const {files} = action.payload;
      let uploadedFiles = [];
      if (files && files.length > 0) {
        uploadedFiles = files.map((file) =>
          file && file instanceof File && file.name ? file.name : ''
        );
      }
      return {
        ...state,
        isUploadingCounter: state.isUploadingCounter + 1,
        uploadedFiles,
      };
    }
    case at.UPLOAD_FAILURE: {
      return {
        ...state,
        isUploadingCounter: Math.max(state.isUploadingCounter - 1, 0),
        isUploadSuccessful: false,
      };
    }
    case at.UPLOAD_SUCCESS: {
      return {
        ...state,
        isUploadingCounter: Math.max(state.isUploadingCounter - 1, 0),
        isUploadSuccessful: true,
      };
    }
  }
  return state;
}

export default reducer;
